import * as THREE from "three";
import Experience from "../Experience.js";

export default class Monitor {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.time = this.experience.time;
    this.debug = this.experience.debug;

    // Debug
    if (this.debug.active) {
      this.debugFolder = this.debug.ui.addFolder("Monitor");
    }

    // Resource
    this.resource = this.resources.items.monitorModel;

  //  this.setTextures();
    this.setModel();

  }

  setTextures(){
    this.textures = {};
    this.textures.color = this.resources.items.monitorBackgroundTexture;
    this.textures.color.encoding = THREE.sRGBEncoding;
    this.textures.center = 0.5, 0.5;
    this.textures.rotation = 3

  }

  setModel() {
    this.model = this.resource.scene;
    this.model.position.set(0.45, -0.35, 0.2);
    this.model.name = "monitor";

    this.monitorScreen = this.model.children[0].children[2];

    this.monitorScreen.material.color.set('white')
    this.monitorScreen.material.color.encoding = THREE.sRGBEncoding
    this.monitorScreen.material.map = this.resources.items.monitorBackgroundTexture;
    this.monitorScreen.material.map.flipY = false;

    this.scene.add(this.model);

    this.model.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.name = this.model.name;
        child.castShadow = true;
      }
    });
  }
}
